import React, {useState} from 'react';
import {Input, Select} from 'antd';
import styles from './layout.module.less'

import store from "./store";
import {observer} from 'mobx-react';

// the hook
import { useTranslation } from 'react-i18next';
import SearchForm, {SearchFormItem} from "../../../components/SearchForm";


export default observer(function () {
  const {t, i18n} = useTranslation()
  const [loading, setLoading] = useState(false)

  const onSearch = (values) => {
    store.spp = values
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 500)
  }

  return (
    <React.Fragment>

      <div className={styles.listTitle}>
        <span className={styles.title} style={{paddingLeft:'0.0781rem'}}>{t('我的订单')}</span>
      </div>

      <SearchForm onFinish={onSearch} height='160px'>
        <SearchFormItem title={t('产品名称')} name='name' span={8}>
          <Input placeholder={t("请输入")} allowClear/>
        </SearchFormItem>
        <SearchFormItem title={t('订单编号')} name='order_sn' span={8}>
          <Input placeholder={t("请输入")} allowClear/>
        </SearchFormItem>
        <SearchFormItem title={t('项目编号')} name='extra_sn' span={8}>
          <Input placeholder={t("请输入")} allowClear/>
        </SearchFormItem>
        <SearchFormItem title={t('中心号')} name='center_sn' span={8}>
          <Input placeholder={t("请输入")} allowClear/>
        </SearchFormItem>
        <SearchFormItem title={t('货号')} name='factory_code' span={8}>
          <Input placeholder={t("请输入")} allowClear/>
        </SearchFormItem>
        <SearchFormItem title={t('PO号')} name='po_sn' span={8}>
          <Input placeholder={t("请输入")} allowClear/>
        </SearchFormItem>
        <SearchFormItem title={t('品牌')} name='brand' span={8}>
          <Input placeholder={t("请输入")} allowClear/>
        </SearchFormItem>
        <SearchFormItem title={t('订单类型')} name='type' span={8}>
          <Select placeholder={t("请选择")}>
            <Select.Option value="0">{t('全部')}</Select.Option>
            <Select.Option value="2">{t('租赁')}</Select.Option>
            <Select.Option value="1">{t('购买')}</Select.Option>
          </Select>
        </SearchFormItem>
      </SearchForm>

    </React.Fragment>
  )
})
